// French translations - Default language
export const fr = {
  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    none: 'Aucun',
    yes: 'Oui',
    no: 'Non',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Envoyer',
    confirm: 'Confirmer',
    required: 'Requis',
    optional: 'Optionnel',
    scroll: 'Défiler',
  },

  // Navigation
  nav: {
    home: 'Accueil',
    book: 'Réserver',
    myRaces: 'Mes courses',
    sites: 'Nos sites',
    faq: 'FAQ',
    contact: 'Contact',
    bookNow: 'Réserver maintenant',
    login: 'Connexion',
    logout: 'Déconnexion',
    profile: 'Mon profil',
  },

  // Hero Section
  hero: {
    newInCorsica: 'Nouveau en Corse !',
    title: 'Boat Racing Experience',
    subtitle: 'Vivez une expérience de course 100% immersive ! Pilotez des bateaux FPV en vue embarquée sur l\'eau.',
    sensations: 'Sensations garanties.',
    bookRace: 'Réserver ma course',
    discoverConcept: 'Découvrir le concept',
    stats: {
      speed: 'km/h',
      pilots: 'pilotes',
      minutes: 'minutes',
      funGuaranteed: 'fun garanti',
    },
  },

  // Concept Section
  concept: {
    badge: 'LE CONCEPT',
    title: 'La course FPV sur l\'eau',
    subtitle: 'Imaginez piloter un bateau de course à grande vitesse, avec une vue embarquée comme si vous étiez à bord. C\'est ça, Aqua-Rush !',
    features: {
      piloting: {
        icon: '🎮',
        title: 'Pilotage intuitif',
        desc: 'Télécommande ergonomique et bateaux réactifs. Accessible dès 8 ans !',
      },
      immersive: {
        icon: '🥽',
        title: 'Vue immersive',
        desc: 'Casque ou écran pour plonger dans le cockpit. Vous voyez ce que le bateau voit !',
      },
      competition: {
        icon: '🏁',
        title: 'Compétition palpitante',
        desc: 'Jusqu\'à 4 pilotes s\'affrontent en circuit aquatique. Qui sera le plus rapide ?',
      },
      memories: {
        icon: '📸',
        title: 'Souvenirs mémorables',
        desc: 'Vos temps, photos et exploits à partager sur les réseaux !',
      },
    },
  },

  // How It Works
  howItWorks: {
    badge: 'COMMENT ÇA MARCHE',
    title: 'En route vers la',
    titleHighlight: 'victoire',
    subtitle: 'De la réservation au podium, c\'est simple comme bonjour !',
    cta: 'C\'est parti, je réserve !',
    steps: {
      book: {
        num: '01',
        icon: '📱',
        title: 'Réservez',
        desc: 'Choisissez votre créneau et payez en quelques clics sécurisés.',
      },
      install: {
        num: '02',
        icon: '🎯',
        title: 'Briefing',
        desc: '5 min pour maîtriser les commandes avec notre équipe.',
      },
      race: {
        num: '03',
        icon: '🏁',
        title: 'En piste',
        desc: '5 min de course intense avec 5 tours chronométrés.',
      },
      win: {
        num: '04',
        icon: '🏆',
        title: 'Célébrez',
        desc: 'Podium, photos et temps. Des souvenirs mémorables.',
      },
    },
  },

  // Pricing
  pricing: {
    badge: 'NOS TARIFS',
    title: 'Des sensations à',
    titleHighlight: 'prix malin',
    subtitle: 'Choisissez la formule qui vous convient. Tout est inclus !',
    plans: [
      {
        name: 'Solo',
        desc: 'Une course, une expérience',
        price: 15,
        features: ['1 course de 5 minutes', '5 tours chronométrés', 'Casque FPV fourni', 'Accès aux temps en ligne'],
        popular: false,
      },
      {
        name: 'Duo Pack',
        desc: 'À deux, c\'est mieux !',
        price: 25,
        priceNote: 'pour 2 personnes',
        features: ['2 courses de 5 minutes', 'Affrontez-vous en duel !', 'Casques FPV fournis', 'Photos souvenirs', 'Accès aux temps en ligne'],
        popular: true,
      },
      {
        name: 'Team 4',
        desc: 'La totale entre amis',
        price: 45,
        priceNote: 'pour 4 personnes',
        features: ['4 courses de 5 minutes', 'Battle royale à 4 !', 'Casques FPV fournis', 'Photos & vidéos', 'Podium personnalisé', 'Replay de la course'],
        popular: false,
      },
    ],
    cta: 'Réserver',
    popular: 'Populaire',
    note: '💳 Paiement sécurisé • 🔄 Annulation gratuite jusqu\'à 24h avant',
    description: 'Choisissez la formule qui vous convient. Tout est inclus !',
  },

  // Features
  features: {
    badge: 'POURQUOI NOUS CHOISIR',
    title: 'Une expérience',
    subtitle: 'inoubliable',
    items: {
      fun: {
        icon: '🎉',
        title: 'Fun garanti',
        desc: 'Une activité originale et accessible pour tous, de 8 à 88 ans !',
      },
      tech: {
        icon: '📡',
        title: 'Technologie FPV',
        desc: 'Immersion totale avec caméra embarquée HD et transmission temps réel.',
      },
      competition: {
        icon: '🏆',
        title: 'Compétition',
        desc: 'Classements, records personnels, podiums. Qui sera le champion ?',
      },
      social: {
        icon: '👨‍👩‍👧‍👦',
        title: 'Moments partagés',
        desc: 'Parfait entre amis, en famille ou pour des événements d\'entreprise.',
      },
      outdoor: {
        icon: '🎁',
        title: 'Formules groupe',
        desc: 'Anniversaires, EVG/EVJF, team building : on s\'adapte.',
      },
      safe: {
        icon: '🛡️',
        title: 'Sécurité maximale',
        desc: 'Équipements professionnels et encadrement par nos experts.',
      },
    },
  },

  // Video Showcase
  video: {
    badge: 'EN ACTION',
    title: 'Voyez par',
    titleHighlight: 'vous-même',
    subtitle: 'Plongez dans l\'action avec nos vidéos de courses en FPV !',
    close: 'Fermer',
    videos: [
      { title: 'Course intense en FPV' },
      { title: 'Sensations garanties' },
    ],
  },

  // Testimonials
  testimonials: {
    badge: 'TÉMOIGNAGES',
    title: 'Ils ont',
    titleHighlight: 'adoré',
    list: [
      {
        name: 'Thomas M.',
        location: 'Paris',
        avatar: '👨',
        text: 'Une expérience de dingue ! On a fait ça avec les enfants, ils en parlent encore. Les sensations en FPV sont vraiment uniques.',
      },
      {
        name: 'Sophie L.',
        location: 'Lyon',
        avatar: '👩',
        text: 'Parfait pour un EVJF original ! On a ri, on s\'est chambrées, le staff était top. Je recommande à 1000% !',
      },
      {
        name: 'Marc D.',
        location: 'Marseille',
        avatar: '🧔',
        text: 'Ancien pilote de drone FPV, j\'ai adoré le concept sur l\'eau. C\'est encore plus fun ! Vivement la prochaine.',
      },
      {
        name: 'Julie R.',
        location: 'Bordeaux',
        avatar: '👧',
        text: 'Mon fils de 10 ans a battu son père ! L\'écran géant avec le classement, c\'est super pour l\'ambiance.',
      },
    ],
    stats: {
      rating: '4.9/5',
      onGoogle: 'sur Google',
      races: 'courses',
      satisfied: 'satisfaits',
    },
  },

  // Sites
  sites: {
    badge: 'NOS SITES',
    title: 'Où nous',
    titleHighlight: 'trouver',
    subtitle: 'Des emplacements d\'exception pour des courses mémorables',
    open: 'Ouvert',
    comingSoon: 'Bientôt',
    opening: 'Bientôt disponible',
    viewDetails: 'Voir tous nos sites',
    bookNow: 'Réserver ici',
    list: [
      {
        slug: 'porto-vecchio',
        name: 'Porto-Vecchio',
        location: 'Corse du Sud',
        image: '🏝️',
        desc: 'Au cœur de la Cité du Sel, profitez d\'un cadre exceptionnel avec vue sur la mer.',
        status: 'open',
        features: ['Vue mer', 'Parking gratuit', 'Bar sur place'],
      },
      {
        slug: 'saint-tropez',
        name: 'Saint-Tropez',
        location: 'Var',
        image: '⛵',
        desc: 'Sur le port mythique, une expérience FPV dans un décor de carte postale.',
        status: 'soon',
        features: ['Port de plaisance', 'Restaurant', 'Terrasse'],
      },
      {
        slug: 'biarritz',
        name: 'Biarritz',
        location: 'Pyrénées-Atlantiques',
        image: '🏄',
        desc: 'L\'esprit basque rencontre la technologie FPV pour des sensations uniques.',
        status: 'soon',
        features: ['Plage', 'Surf nearby', 'Ambiance festive'],
      },
    ],
  },

  // FAQ
  faq: {
    badge: 'FAQ',
    title: 'Questions fréquentes',
    subtitle: 'Tout ce que vous devez savoir',
    questions: [
      {
        q: 'Quel âge minimum pour piloter ?',
        a: 'L\'activité est accessible dès 8 ans. Les enfants de moins de 12 ans doivent être accompagnés d\'un adulte.',
      },
      {
        q: 'Combien de temps dure une course ?',
        a: 'Une course standard dure 7 minutes. C\'est suffisant pour faire plusieurs tours et vivre des sensations fortes !',
      },
      {
        q: 'Faut-il de l\'expérience ?',
        a: 'Non ! Un briefing de 2 minutes vous explique les commandes. C\'est accessible à tous les niveaux.',
      },
      {
        q: 'Peut-on réserver pour un groupe ?',
        a: 'Oui ! Nous proposons des formules groupe et des privatisations pour les anniversaires, EVG/EVJF et entreprises.',
      },
      {
        q: 'Que se passe-t-il en cas de panne ?',
        a: 'Nos bateaux sont régulièrement entretenus. En cas de problème technique, vous serez remboursé ou redirigé vers une autre session.',
      },
      {
        q: 'Puis-je annuler ma réservation ?',
        a: 'Oui, annulation gratuite jusqu\'à 24h avant. Voir nos CGV pour plus de détails.',
      },
    ],
    moreQuestions: 'Vous avez d\'autres questions ?',
    contactUs: 'Contactez-nous',
  },

  // Booking
  booking: {
    title: 'Réserver',
    subtitle: 'Choisissez votre créneau',
    selectSite: 'Sélectionnez un site',
    selectDate: 'Choisissez une date',
    selectTime: 'Choisissez un horaire',
    selectFormula: 'Choisissez votre formule',
    participants: 'Nombre de participants',
    yourInfo: 'Vos informations',
    name: 'Nom complet',
    email: 'Email',
    phone: 'Téléphone',
    notes: 'Notes (optionnel)',
    total: 'Total',
    pay: 'Payer',
    confirmBooking: 'Confirmer la réservation',
    bookingConfirmed: 'Réservation confirmée !',
    bookingCode: 'Code de réservation',
    checkEmail: 'Vous recevrez un email de confirmation.',
  },

  // My Races
  myRaces: {
    title: 'Mes Courses',
    subtitle: 'Votre historique et statistiques',
    noRaces: 'Vous n\'avez pas encore participé à des courses.',
    bookFirst: 'Réserver ma première course',
    totalRaces: 'Courses totales',
    bestLap: 'Meilleur tour',
    avgPosition: 'Position moyenne',
    history: 'Historique',
    date: 'Date',
    site: 'Site',
    position: 'Position',
    lapTime: 'Temps au tour',
  },

  // Contact
  contact: {
    badge: 'CONTACT',
    title: 'Une question ?',
    subtitle: 'Notre équipe vous répond rapidement',
    form: {
      name: 'Votre nom',
      email: 'Votre email',
      subject: 'Sujet',
      message: 'Votre message',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      sent: 'Message envoyé !',
      error: 'Erreur lors de l\'envoi',
    },
    info: {
      title: 'Informations',
      email: 'Email',
      emailAddress: 'contact@aqua-rush.fr',
      phone: 'Téléphone',
      phoneNumber: '+33 4 XX XX XX XX',
      address: 'Adresse',
      addressLine: 'Porto-Vecchio, Corse',
    },
    social: {
      title: 'Suivez-nous',
      instagram: 'Instagram',
      facebook: 'Facebook',
      youtube: 'YouTube',
    },
  },

  // CTA Section
  cta: {
    title: 'Prêt à vivre l\'expérience ?',
    subtitle: 'Réservez votre course dès maintenant et découvrez les sensations uniques d\'Aqua-Rush.',
    button: 'Réserver maintenant',
    or: 'ou',
    moreInfo: 'En savoir plus',
    securePayment: 'Paiement sécurisé',
    freeCancellation: 'Annulation gratuite',
    rating: '4.9/5 sur Google',
    question: 'Une question ?',
  },

  // Footer
  footer: {
    tagline: 'Boat Racing Experience - L\'expérience de course FPV unique !',
    navigation: 'Navigation',
    info: 'Informations',
    legal: 'Mentions légales',
    terms: 'CGV',
    privacy: 'Politique de confidentialité',
    rights: 'Tous droits réservés.',
    madeWith: 'Fait avec',
    inCorsica: 'en Corse',
  },

  // Cockpit App
  cockpit: {
    dashboard: 'Dashboard',
    race: 'Course',
    queue: 'File d\'attente',
    boats: 'Bateaux',
    register: 'Caisse',
    kpis: 'KPIs',
    clients: 'Clients',
    team: 'Équipe',
    screens: 'Écrans',
    settings: 'Paramètres',
    greeting: 'Bonjour',
    todayRaces: 'Courses du jour',
    participants: 'Participants',
    revenue: 'CA du jour',
    fillRate: 'Taux de remplissage',
    vsYesterday: 'vs hier',
    quickActions: 'Actions rapides',
    startRace: 'Lancer une course',
    addToQueue: 'Ajouter à la file',
    todayPlanning: 'Planning du jour',
    currentRace: 'Course en cours',
    finished: 'Terminée',
    scheduled: 'Programmée',
    connected: 'Connecté',
    offline: 'Hors ligne',
    raceInProgress: 'Course en cours',
    participantsReady: 'participants prêts',
    peopleWaiting: 'personnes en attente',
    boatStatus: {
      available: 'Disponible',
      inUse: 'En course',
      charging: 'En charge',
      maintenance: 'Maintenance',
    },
    actions: {
      call: 'Appeler',
      remove: 'Retirer',
      startRace: 'Démarrer',
      stopRace: 'Arrêter',
      pauseRace: 'Pause',
    },
  },

  // Displays App
  displays: {
    raceLeaderboard: 'Classement Course',
    liveUpdates: 'Mises à jour en direct',
    raceTime: 'Temps de course',
    noParticipants: 'Aucun participant',
    waitingForRace: 'En attente du départ...',
    position: 'Position',
    pilot: 'Pilote',
    boat: 'Bateau',
    laps: 'Tours',
    bestLap: 'Meilleur tour',
    lastLap: 'Dernier tour',
    gap: 'Écart',
    raceControl: 'Contrôle Course',
    leader: 'Leader',
    finished: 'Terminé',
    dnf: 'Abandon',
  },

  // Franchise App
  franchise: {
    title: 'Devenez franchisé FPV',
    subtitle: 'La révolution du divertissement aquatique',
    launchCenter: 'Lancez votre centre de courses de bateaux FPV et générez des revenus importants.',
    uniqueOpportunity: 'Une opportunité unique avec un secteur en croissance exponentielle.',
    discoverOpp: 'Découvrir l\'opportunité',
    bookMeeting: 'Prendre un rendez-vous',
    sitesOperating: 'Sites en opération',
    participantsMonth: 'Participants/mois',
    avgROI: 'ROI moyen',
    advantages: 'Avantages',
    advantagesDesc: 'Pourquoi rejoindre le réseau Aqua-Rush',
    faq: 'FAQ',
    faqDesc: 'Questions fréquentes des franchisés',
    contact: 'Contact',
    contactDesc: 'Contactez notre équipe franchise',
    franchiseeArea: 'Espace Franchisé',
    apply: 'Candidater',
    turnkey: 'Clé en main',
    turnkeyDesc: 'Installation complète avec formation et support continu',
    digitalEco: 'Écosystème digital',
    digitalEcoDesc: 'Applications propriétaires incluses (cockpit, displays, client)',
    exclusivity: 'Exclusivité territoriale',
    exclusivityDesc: 'Zone géographique protégée pour maximiser votre potentiel',
    support: 'Support 24/7',
    supportDesc: 'Équipe dédiée pour vous accompagner au quotidien',
    conceptDesc: 'Un concept unique de course de bateaux FPV',
    howItWorks: 'Comment ça marche',
    businessModel: 'Modèle économique',
    businessModelDesc: 'Un business model éprouvé et rentable',
    revenueSource: 'Sources de revenus',
    marginEvolution: 'Évolution des marges',
    investmentAndFees: 'Investissement et redevances',
    phone: 'Téléphone',
    email: 'Email',
    response24h: 'Réponse sous 24h',
    address: 'Adresse',
    headquarters: 'Siège social',
    thank: 'Merci !',
    successMessage: 'Votre demande a bien été envoyée. Nous vous recontacterons rapidement.',
    fullName: 'Nom complet',
    city: 'Ville',
    message: 'Message',
    messagePlaceholder: 'Parlez-nous de votre projet...',
    sending: 'Envoi en cours...',
    submit: 'Envoyer ma candidature',
    investment: {
      title: 'Investissement',
      initial: 'Apport initial',
      roi: 'ROI estimé',
      payback: 'Retour sur investissement',
      recommended: 'Recommandé',
      timeline: 'Calendrier d\'investissement',
    },
    dashboard: {
      welcome: 'Bienvenue',
      yourSite: 'Votre site',
      todayStats: 'Statistiques du jour',
      monthStats: 'Ce mois',
      yearStats: 'Cette année',
    },
  },

  // Time
  time: {
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    tomorrow: 'Demain',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    minutes: 'min',
    hours: 'h',
    days: 'j',
    ago: 'il y a',
  },

  // Errors
  errors: {
    generic: 'Une erreur est survenue',
    network: 'Erreur de connexion',
    notFound: 'Page non trouvée',
    unauthorized: 'Accès non autorisé',
    serverError: 'Erreur serveur',
    tryAgain: 'Réessayer',
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TranslationKeys = typeof fr;
